import http from "@/services/http";

/**
 * Lista os exames já registrados de um paciente (tabela exams).
 *
 * Usado na busca "@" da prescrição para oferecer o que o paciente já tem —
 * repetir um exame é pedido clínico comum, e sem isso o médico redigita o nome
 * e cria uma segunda linha do mesmo exame.
 *
 * @param {number|string} patientId
 * @returns {Promise<object[]>} lista de exams (`{ id, exam_name, status, date, ... }`)
 */
export async function getExamsByPatient(patientId) {
  const { data } = await http.get(`/api/exams/get-all-exams/${patientId}`);
  return data?.success ? data.data || [] : [];
}
